import { useQueryConnect } from '../hooks/useQueryConnect';

export function UseQueryConnect({ children, _key, params }) {
  const result = useQueryConnect(_key, params);
  return children(result);
}
